import Transfer from 'antd/lib/transfer'

import 'antd/lib/transfer/style'

export * from 'antd/lib/transfer'

export default Transfer
